<template>
    <v-container>
        <h1 class="page-heading">Marketplace</h1>
        <router-link to="marketplace">
            <p class="text-sm font-yellow">Back to Marketplace</p>
        </router-link>
    </v-container>
    <v-container class="highlights">
        <div class="highlights-block your-listings">
            <p class="subtitle">Your Listings</p>
            <div v-if="listings.length != 0">
                <div
                    v-for="listing in listings"
                    :key="listing.id"
                    class="row-item"
                >
                    <div class="row-item__full-width">
                        <p class="text-sm">
                            {{
                                new Date(
                                    listing.date.seconds * 1000
                                ).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric",
                                })
                            }}
                        </p>
                    </div>
                    <div class="row-item__full-width">
                        <div class="row-item__data--left">
                            <p class="text mr-2">
                                {{ listing.total_energy }} kWh
                            </p>
                            <p class="text-sm data-pill">
                                RM{{ listing.total_price }}
                            </p>
                        </div>
                        <div class="row-item__data--right">
                            <p>{{ listing.status }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="text-sm ml-3 mt-3">Nothing to show.</p>
            </div>
        </div>
        <div class="highlights-block your-purchases">
            <p class="subtitle">Your Purchases</p>
            <div v-if="purchases.length != 0">
                <div
                    v-for="purchase in purchases"
                    :key="purchase.id"
                    class="row-item"
                >
                    <div class="row-item__full-width">
                        <p class="text-sm">
                            {{
                                new Date(
                                    purchase.buy_date.seconds * 1000
                                ).toLocaleDateString("en-GB", {
                                    day: "numeric",
                                    month: "numeric",
                                    year: "numeric",
                                })
                            }}
                        </p>
                    </div>
                    <div class="row-item__full-width">
                        <div class="row-item__data--left">
                            <p class="text mr-2">
                                {{ purchase.total_energy }} kWh
                            </p>
                            <p class="text-sm data-pill">
                                RM{{ purchase.total_price }}
                            </p>
                        </div>
                        <div class="row-item__data--right">
                            <p>{{ purchase.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="text-sm ml-3 mt-3">Nothing to show.</p>
            </div>
        </div>
    </v-container>
</template>

<script>
import {
    collection,
    getFirestore,
    getDocs,
    query,
    where,
} from "firebase/firestore";
import store from "@/store";
export default {
    name: "MarketplaceHighlightsView",
    data() {
        return {
            listings: [],
            purchases: [],
            db: getFirestore(),
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getListings() {
            this.listings = [];
            const q = query(
                collection(this.db, "listings"),
                where("user_id", "==", store.state.user?.user_id)
            );
            getDocs(q)
                .then((res) => {
                    if (res != undefined) {
                        res.docs.forEach((doc) =>
                            this.listings.push(doc.data())
                        );
                    }
                })
                .catch((e) => console.log(e));
        },
        getPurchases() {
            this.purchases = [];
            const q = query(
                collection(this.db, "listings"),
                where("buyer_id", "==", store.state.user?.user_id)
            );
            getDocs(q)
                .then((res) => {
                    if (res != undefined) {
                        res.docs.forEach((doc) =>
                            this.purchases.push(doc.data())
                        );
                    }
                })
                .catch((e) => console.log(e));
        },
        getData() {
            this.getListings();
            this.getPurchases();
        },
    },
};
</script>

<style lang="scss">
h1 {
    font-size: 50px;
    color: $black;
}
.highlights {
    display: flex;
    justify-content: space-between;
    &-block {
        flex: 1 1 0px;
        margin: 10px;

        .subtitle {
            background-color: $bg-gray;
            padding: 10px;
            border-radius: 8px;
        }

        .row-item {
            display: flex;
            flex-direction: column;
            padding: 10px 5px;
            border-bottom: solid 1px $light-gray;
            &__full-width {
                display: flex;
                justify-content: space-between;
            }
            &__data {
                &--left {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .data-pill {
                        background-color: $yellow;
                        padding: 2px 10px 1px 10px;
                        border-radius: 50px;
                        font-size: 13px;
                    }
                }
            }
        }
    }
}
</style>
